<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="pscols"
          [value]="partnerBulkEmailTrackingList"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="500px"
          dataKey="emailBatchId"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          (onPage)="pageChange($event)"
          (onFilter)="applyFilter($event)">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <input
                type="text"
                pInputText
                size="30"
                placeholder="Search"
                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                style="width: auto"
                [value]="
                  dt.filters['global'] ? $any(dt.filters['global']).value : ''
                " />
              <i class="fa fa-search ml-2"></i>
              <span class="pageInfo visiblelg resettble">{{
                currentPageInfo
              }}</span>
              <span style="float: right; position: relative; top: 12px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header let-columns>
            <tr class="row">
              <th [pSortableColumn]="'templateName'" class="colmedium">
                Name<p-sortIcon [field]="'templateName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'recipientCategoryName'" class="collarge">
                Recipients<p-sortIcon
                  [field]="'recipientCategoryName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'emailSentDate'" class="colsmall">
                Date<p-sortIcon [field]="'emailSentDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'status'" class="colsmall">
                Status<p-sortIcon [field]="'status'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'partnerInputCustomerName'"
                class="colsmall">
                Export
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr class="row">
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.templateName }}"
                  >{{ rowData.templateName }}</span
                >
              </td>
              <td class="collarge">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.recipientCategoryName }}"
                  >{{ rowData.recipientCategoryName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.emailSentDate }} "
                  >{{ rowData.emailSentDate | date: 'short' }}</span
                >
              </td>
              <td class="colsmall">
                <span tooltipPosition="top" pTooltip="{{ rowData.status }}">{{
                  rowData.status ? 'Success' : 'Failure'
                }}</span>
              </td>
              <td class="colsmall">
                <button
                  type="button"
                  (click)="export(rowData.emailBatchId)"
                  pButton
                  icon="fa fa-file-zip-o"
                  iconPos="left"
                  class="ui-button-success">
                  Export
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
